import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SuccessDialog {
    private readonly dialogRef = inject<MatDialogRef<SuccessDialog>>(MatDialogRef);
    private readonly router = inject(Router);
    public data = inject<{ displayId: string }>(MAT_DIALOG_DATA);

    public close(): void {
        this.dialogRef.close();
    }

    public navigateToDashboard(): void {
        this.dialogRef.close();
        this.router.navigate(['/']);
    }
}
